import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=0d08857f&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=ts"
export * from "./Edit.vue?vue&type=script&lang=ts"
import style0 from "./Edit.vue?vue&type=style&index=0&id=0d08857f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d08857f",
  null
  
)

export default component.exports